import React from 'react';

import styled from 'styled-components';
import { isEmpty } from 'util/isEmpty';

const InputItem = (props) => {

    return (
        <React.Fragment>
            <Input
                style={{fontSize:props.fontSize ? props.fontSize : 14}}                    
                required={!isEmpty(props.required) ? props.required : false}
                placeholder={props.placeholder}
                type={!isEmpty(props.type) ? props.type : "text"}
                value={props.value}
                onChange={props.onChange}
                className={(props.value !== "" && props.warn === true) ? "warn" : ""}
            />
            {props.value !== "" && props.warn === true && <WarnText>{props.warnningMessage}</WarnText>}
        </React.Fragment>
    );
};
export default InputItem;

const Input = styled.input`
    font-family: Arial;
    padding: 21px 16px;
    font-weight: 400;
    font-size: 16px;
    color: #000;
    border: 1px solid #ddd;
    border-radius: 5px;
    display: block;
    width: 100%;
    -webkit-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;   
    &::placeholder{
        color:#999;
    } 
    &.warn{
        outline: #ea4335 solid 1px;
    }
    &:focus {
        outline: 1.5px solid #e0c463;
        &.warn{
        outline: #ea4335 solid 1px;
    }
    }
`;
const WarnText = styled.p`
    margin-top: 8px;
    font-size: 14px;
    font-weight: 400;
    font-family: "Arial";
    color: #ea4335 !important;
`;
